import { ICallback } from '../../../interfaces/ICallback';
import { dateNow } from './dateNow';

if (typeof window === 'undefined') {
    // @ts-ignore
    // eslint-disable-next-line
    requestAnimationFrame = setTimeout;
    // @ts-ignore
    // eslint-disable-next-line
    cancelAnimationFrame = clearTimeout;
}

const requestInterval = (callback: ICallback, delay: number, shiftFirstInterval = 0): ICallback => {
    let start = dateNow(delay);
    let requestId: number;
    let isFirstInterval = true;

    const loop = (): void => {
        requestId = requestAnimationFrame(loop);

        const current = dateNow(delay);
        const delta = Math.abs(current - start);

        if (delta >= (isFirstInterval && shiftFirstInterval ? delay - shiftFirstInterval : delay)) {
            isFirstInterval = false;
            callback.call(null);
            start = current;
        }
    };

    requestId = requestAnimationFrame(loop);

    return () => {
        cancelAnimationFrame(requestId);
    };
};

export default requestInterval;
